// extracted by mini-css-extract-plugin
export default {"categorySelector":"Home_categorySelector__S8Q9d","catalogLabel":"Home_catalogLabel__v2+JH","categoryButton":"Home_categoryButton__5BCW-"};